// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"225":"697df3fe","838":"652e68f8"}[chunkId] + ".js";
};